"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useGlobalMessage2 = _interopRequireDefault(require("../hooks/useGlobalMessage"));

var _MessageDialog = _interopRequireDefault(require("./MessageDialog"));

var _MessageSnackbar = _interopRequireDefault(require("./MessageSnackbar"));

var Message = function Message() {
  var _useGlobalMessage = (0, _useGlobalMessage2["default"])(),
      variant = _useGlobalMessage.variant;

  switch (variant) {
    case 'snackbar':
      return /*#__PURE__*/_react["default"].createElement(_MessageSnackbar["default"], null);

    case 'dialog':
      return /*#__PURE__*/_react["default"].createElement(_MessageDialog["default"], null);

    default:
      return null;
  }
};

var _default = /*#__PURE__*/(0, _react.memo)(Message);

exports["default"] = _default;